import { Image, Modal } from '@/atoms';
import { OffertaForm } from '@/bloks/Form/OffertaForm';
import { useOffertaModal } from '@/contexts/offerta-modal/OffertaModalProvider';
import { cls } from '@/utils';
import { t } from 'ttag';
import styles from './OffertaModal.module.scss';

export const OffertaModal = () => {
	const { showModal, setShowModal } = useOffertaModal();

	return (
		<Modal
			className={cls(styles.offertaModal, 'piwikTrackContent')}
			show={showModal}
			onClose={() => setShowModal(false)}
			dataContentName={'Offerta form'}
		>
			<div className={styles.image}>
				<Image src={'/offerta-logo.svg'} alt={'Offerta logotyp'} loading="eager" width={66} height={32} />
				<div className={styles.text}>{t`en del av Fortnox`}</div>
			</div>
			<div className={styles.formWrapper}>
				<OffertaForm />
			</div>
		</Modal>
	);
};
